/**
 * Scroll-spy for the "Cleogene navigation" section: marks the menu link whose
 * anchor is currently in view with `aria-current`. Clicking a link needs no JS
 * (native anchor + CSS smooth scroll + scroll-margin on the anchor).
 */
class CleogeneNavigation extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    /** @type {Map<string, Element>} */
    const links = new Map();
    for (const link of this.querySelectorAll('a[href^="#"]')) {
      links.set(decodeURIComponent(link.hash.slice(1)), link);
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          for (const [id, link] of links) {
            if (id === entry.target.id) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          }
        }
      },
      { rootMargin: '-120px 0px -60% 0px' }
    );

    for (const anchor of this.querySelectorAll('[data-cleogene-anchor]')) {
      this.#observer.observe(anchor);
    }
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('cleogene-navigation')) {
  customElements.define('cleogene-navigation', CleogeneNavigation);
}
